<script lang="ts" setup>
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useAcceptAppConsentMutation } from "@/graphql/operations";
import { Brand } from "@/components";

const store = useStore();

const { executeMutation } = useAcceptAppConsentMutation();

const appConsentGiven = computed(() => store.getters.user.appConsentGiven);

const visible = ref(
  store.getters.user.hasAppConsentBanner() && !appConsentGiven.value,
);

watch(appConsentGiven, (newValue, oldValue) => {
  visible.value = store.getters.user.hasAppConsentBanner() && newValue;
});

const saveConsent = async () => {
  const res = await executeMutation({
    id: store.getters.user.postgresId,
    now: new Date(),
  });

  if (!res.error) {
    visible.value = false;
  }
};
</script>

<template>
  <teleport to="body" v-if="visible">
    <div class="modal-wrapper">
      <div class="modal">
        <div class="logo_container">
          <Brand />
        </div>

        <p class="info">
          {{ store.getters.user.mergedConfig?.appConsent?.text }}
        </p>

        <div>
          <a
            class="link"
            v-for="(link, i) in store.getters.user.mergedConfig?.appConsent
              ?.links"
            :key="i"
            :href="link.href"
          >
            {{ link.label }}
          </a>
        </div>

        <div class="button_container">
          <button class="button primary" @click="saveConsent">
            {{ $t("appConsent.confirm") }}
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<style scoped lang="scss">
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  backdrop-filter: blur(5px);
  z-index: 10;
  display: grid;
}

.modal {
  place-self: center center;
  background-color: var(--classic-surface, white);
  border-radius: 4px;
  padding: 2rem;
  box-shadow: 0 2px 9px rgba(0, 0, 0, 0.4);
  width: 50%;
  max-width: 800px;
}

.button_container {
  display: flex;
  justify-content: flex-end;
  margin-top: 1em;
}

p {
  white-space: pre-line;
  font-size: 0.9rem;
}

a {
  display: inline-block;
  font-size: 0.9rem;
}
</style>
